import React, { useState } from "react";
import { ref, set } from "firebase/database";
import { db } from "../firebase"; // Import the initialized Firebase instance
import "./RsvpForm.css";

const ReceptionRSVPForm= ({ isOpen, onClose }) => {
  const [submitted, setSubmitted] = useState(false);
  const [numGuests, setNumGuests] = useState(1);
  const [guestDetails, setGuestDetails] = useState([{ firstName: "", lastName: "" }]);
  const [eventSelection, setEventSelection] = useState("I am coming to the reception");

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();

    // Collect form data
    const formData = {
      email: e.target.elements.email.value,
      guests: guestDetails,
      eventSelection,
    };

    // Create a unique reference for each RSVP
    const rsvpRef = ref(db, "rsvps/" + Date.now()); // Using timestamp as key
    
    // Write to Firebase Realtime Database
    set(rsvpRef, formData)
      .then(() => {
        console.log("RSVP data saved successfully!");
        setSubmitted(true);
      })
      .catch((error) => {
        console.error("Error saving data:", error);
        alert("Something went wrong. Please try again.");
      });
  };

  const handleGuestChange = (index, field, value) => {
    const updatedGuests = [...guestDetails];
    updatedGuests[index][field] = value;
    setGuestDetails(updatedGuests);
  };

  const handleNumGuestsChange = (e) => {
    const count = parseInt(e.target.value, 10);
    setNumGuests(count);
    setGuestDetails(Array.from({ length: count }, () => ({ firstName: "", lastName: "" })));
  };

  return (
    <div className="rsvp-modal">
      <div className="rsvp-form">
        <button className="close-button" onClick={onClose}>×</button>
        {submitted ? (
          <h2>Submitted 🎉</h2>
        ) : (
          <form onSubmit={handleSubmit}>
            <h2>RSVP</h2>
            <p>Please note that this event is couples only.</p>
            <p>RSVP Deadline: March 10th</p>
            <input
              type="email"
              name="email"
              className="rsvp-input"
              placeholder="Your Email"
              required
            />

            <select
              className="rsvp-select"
              value={numGuests}
              onChange={handleNumGuestsChange}
              required
            >
              <option value="1">I am coming alone.</option>
              <option value="2">We are coming as a couple.</option>
            </select>

            <select
              className="rsvp-select"
              value={eventSelection}
              onChange={(e) => setEventSelection(e.target.value)}
              required
            >
              <option value="I am coming to the reception">I am coming to the reception</option>
              <option value="I am not able to come to the reception">I am not able to come to the reception</option>
            </select>

            <div className="guests-container">
              {guestDetails.map((guest, index) => (
                <div key={index} className="guest-input">
                  <input
                    type="text"
                    className="rsvp-input"
                    placeholder={`Guest ${index + 1} First Name`}
                    value={guest.firstName}
                    onChange={(e) =>
                      handleGuestChange(index, "firstName", e.target.value)
                    }
                    required
                  />
                  <input
                    type="text"
                    className="rsvp-input"
                    placeholder={`Guest ${index + 1} Last Name`}
                    value={guest.lastName}
                    onChange={(e) =>
                      handleGuestChange(index, "lastName", e.target.value)
                    }
                    required
                  />
                </div>
              ))}
            </div>

            <button type="submit" className="rsvp-submit">
              Submit
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ReceptionRSVPForm;
